import { render, staticRenderFns } from "./PLanguagePicker.vue?vue&type=template&id=043160e8"
import script from "./PLanguagePicker.vue?vue&type=script&lang=js"
export * from "./PLanguagePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports